/**
 * Created by Allan on 2021/04/26.
 * Contact 84880528@qq.com.
 */
import Frame from '@/layouts/Frame'
export default[
    {
        path:'/role',
        meta:{
            title:'人员管理',
            icon:'el-icon-s-promotion',
            menuId:'17'
        },
        component:Frame,
        children:[
            {
                path:'index',
                name:'roleList',
                meta:{
                    title:'系统角色',
                    keepAlive:true,
                    menuId:'18'
                },
                component:resolve => require(['@/views/role/list/index'], resolve)
            },
            {
                path:'operate/:state',
                name:'operate',
                meta:{
                    title:'操作',
                },
                hidden:true,
                component:resolve => require(['@/views/role/operate/index'], resolve)
            },
        ],
    }
]



// WEBPACK FOOTER //
// ./src/router/map/role.js